import styled from "@emotion/styled";

export const Title = styled.h1`
  text-align: center;
`;
